import { useEffect, useEffectEvent } from "react";

// Shift changes the backslash key’s character to a pipe.
export function useChatpadShortcut(onToggle: () => void, enabled = true) {
  const toggle = useEffectEvent(onToggle);

  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        !e.defaultPrevented &&
        !e.repeat &&
        !e.isComposing &&
        e.shiftKey &&
        !e.altKey &&
        (e.metaKey || e.ctrlKey) &&
        e.code === "Backslash" &&
        !document.querySelector("dialog[open]")
      ) {
        e.preventDefault();
        toggle();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [enabled]);
}
